export default "__VITE_ASSET__DhAUNHGS__"